module.exports = __webpack_public_path__ + "static/assets/306abcf3a285c1d279e1fed22bd74a5c.svg";